export enum RedCardAttribute {
  SecondYellowCard = 414,
  OffField = 702,
  Handball = 3030,
  RefereeAbuseArgument = 3031,
  ViolentConduct = 3032,
  TacticalFoul = 3033,
  SeriousFoul = 3034,
  DangerousPlay = 3035,
}
